export default __webpack_public_path__ + "static/media/stakes-account-bg.555daacd.png";